import Components from "../components";

class Ziptastic extends Components.Base {
  bind() {
    this.on(this.$el.ziptastic(), "zipChange.c-ziptastic", (...args) =>
      this.lookupZipCode(...args),
    );
  }

  lookupZipCode(event, country, state, stateShort, city) {
    const $country = $(this.$el.attr("data-ziptastic-country"));
    const $state = $(this.$el.attr("data-ziptastic-state"));
    const $city = $(this.$el.attr("data-ziptastic-city"));
    $country.val(country);
    $state.val(stateShort);
    return $city.val(city);
  }
}

Components.collection.register({ selector: ".c-ziptastic", klass: Ziptastic });
